import React, { createContext, useContext, useEffect, useState } from 'react';
import { tagsService, Tag } from '../services/tagsService';

interface TagsContextType {
    tags: Tag[];
    loading: boolean;
    error: string | null;
    refreshTags: () => Promise<void>;
}

const TagsContext = createContext<TagsContextType | undefined>(undefined);

export const TagsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [tags, setTags] = useState<Tag[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const loadTags = async () => {
        try {
            console.log('TagsContext: Loading tags...');
            setLoading(true);
            setError(null);
            const fetchedTags = await tagsService.getTags();
            console.log('TagsContext: Tags loaded:', fetchedTags.length);
            setTags(fetchedTags);
        } catch (err) {
            console.error('TagsContext: Error loading tags:', err);
            setError(err instanceof Error ? err.message : 'Failed to load tags');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadTags();
    }, []);

    const refreshTags = async () => {
        tagsService.clearCache();
        await loadTags();
    };

    return (
        <TagsContext.Provider value={{ tags, loading, error, refreshTags }}>
            {children}
        </TagsContext.Provider>
    );
};

export const useTags = () => {
    const context = useContext(TagsContext);
    if (context === undefined) {
        throw new Error('useTags must be used within a TagsProvider');
    }
    return context;
};